import {
    AccountCategory,
    type HolisticSummaryCategory,
    SpendAccountCategory,
} from '@fruitful/types';
import { capitalize } from 'lodash';
import React from 'react';
import { RadioInputRow, Sheet, YStack } from 'smoothie';

import { AccountCategoryIcons } from '../../types/HolisticSummary';

const CategorySelect = ({
    accountCategory,
    accountSpendType,
    isOpen,
    onClose,
    onUpdate,
}: {
    accountCategory?: AccountCategory;
    accountSpendType?: SpendAccountCategory;
    isOpen: boolean;
    onClose: () => void;
    onUpdate: (
        acctCategory: AccountCategory,
        acctSpendType: SpendAccountCategory | null,
    ) => void;
}) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title="Choose a category"
            showCloseButton={false}
        >
            <YStack width="100%">
                {[
                    {
                        acctCategory: AccountCategory.SPEND,
                        acctSpendType: SpendAccountCategory.CASH,
                    },
                    {
                        acctCategory: AccountCategory.SPEND,
                        acctSpendType: SpendAccountCategory.CREDIT,
                    },
                    {
                        acctCategory: AccountCategory.SAVE,
                        acctSpendType: null,
                    },
                    {
                        acctCategory: AccountCategory.INVEST,
                        acctSpendType: null,
                    },
                    {
                        acctCategory: AccountCategory.BORROW,
                        acctSpendType: null,
                    },
                ].map(
                    ({
                        acctCategory,
                        acctSpendType,
                    }: {
                        acctCategory: AccountCategory;
                        acctSpendType: SpendAccountCategory | null;
                    }) => {
                        const label =
                            acctSpendType != null
                                ? `${capitalize(acctCategory)} (${acctSpendType})`
                                : capitalize(acctCategory);
                        return (
                            <RadioInputRow
                                key={acctCategory + acctSpendType}
                                label={label}
                                labelIcon={
                                    AccountCategoryIcons[
                                        acctCategory as HolisticSummaryCategory
                                    ]
                                }
                                isSelected={
                                    accountCategory === acctCategory &&
                                    accountSpendType === acctSpendType
                                }
                                onPress={() => {
                                    onUpdate(acctCategory, acctSpendType);
                                    setTimeout(onClose, 50);
                                }}
                            />
                        );
                    },
                )}
            </YStack>
        </Sheet>
    );
};

export default CategorySelect;
